import { Card, CardContent } from "@/components/ui/card";
import { useToast } from "@/components/ui/use-toast";
import { EnderecoDto } from "@/dtos/EnderedoDto";
import CompraRapidaService, { BuscarClientePorCPFDTO, CadastrarUsuarioCompraRapidaDto } from "@/services/CompraRapidaService";
import EnderecoService from "@/services/EnderecoService";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { NavLink, useNavigate, useSearchParams } from "react-router-dom";
import * as Yup from 'yup';
import { EtapaSelecionarQuantidade } from "./EtapaSelecionarQuantidade";
import { EtapaInserirCPF } from "./EtapaInserirCPF";
import { Button } from "@/components/ui/button";
import { EtapaCadastrar } from "./EtapaCadastrar";
import { EtapaResumo } from "./EtapaResumo";
import { IRealizarLoginDTO } from "@/services/AcessoService";
import { useAuth } from "@/contexts/AuthProvider";
import { ScrollArea } from "@/components/ui/scroll-area"
import SorteioService from "@/services/SorteioService";
import { BuscarSorteioVigenteDto } from "@/dtos/BuscarSorteioVigenteDto";
import CidadesService, { CidadeDto } from "@/services/CidadesService";
import StorageUtils from "@/utils/StorageUtils";
import { DadosCheckoutCompraRapidaDto } from "@/dtos/Request/RequestDadosCheckoutCompraRapida";
import { Separator } from "@/components/ui/separator";
import CompraRapidaOqueE from "@/components/CompraRapidaOqueE";
import { normalizarCPF, validarCPF } from "@/utils/Cpf";
import { validarNomeCompleto } from "@/utils/NomeCompleto";


export enum EtapasCompraRapida {
    SelecionarQuantidade = 0,
    InserirCPF = 1,
    CadastrarDados = 2,
    Resumo = 3,
}

export function CompraRapidaPage() {
    const [quantidade, setQuantidade] = useState(1);
    const [etapa, setEtapa] = useState<EtapasCompraRapida>(EtapasCompraRapida.SelecionarQuantidade);
    const [submiting, setSubmiting] = useState(false)
    const [finalizandoCompra, setFinalizandoCompra] = useState(false)
    const [endereco, setEndereco] = useState<EnderecoDto>();
    const [usuario, setUsuario] = useState<BuscarClientePorCPFDTO>()
    const { toast } = useToast();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const authProps = useAuth();
    const [dadosSorteioVigente, setDadosSorteioVigente] = useState<BuscarSorteioVigenteDto>({} as BuscarSorteioVigenteDto);
    const [cidades, setCidades] = useState<CidadeDto[]>([]);

    useEffect(() => {
        async function buscarSorteioVigente() {
            const result = await SorteioService.buscarSorteioVigente();
            setDadosSorteioVigente(result.Data);
        }

        if (location.pathname.toLowerCase().indexOf('/compra/rapida') >= 0) {
            buscarSorteioVigente();
        }
    }, [])

    useEffect(() => {
        const qtd = searchParams.get('qtd')

        if (qtd && parseInt(qtd) > 0) {
            setQuantidade(parseInt(qtd));

            if (authProps.isAuthorized) {
                formik.setFieldValue('CPF', authProps.usuario?.CPF)
            }

            setEtapa(EtapasCompraRapida.InserirCPF);


            formik.validateForm();
        }
    }, [])

    useEffect(() => {
        let idVendedor = searchParams.get('idVendedor');
        if (idVendedor) {
            StorageUtils.setIdVendedor(idVendedor);
        }
    }, [])

    useEffect(() => {
        buscarCidades();
    }, [])

    async function BuscarPorCep(cep: string) {
        try {
            const { Data: result } = await EnderecoService.buscarPorCep(cep);
            setEndereco(result);
            toast({
                variant: 'success',
                description: 'CEP Válido para compra',
                duration: 4000
            });
        } catch (error: any) {
            toast({
                variant: 'destructive',
                description: error,
                duration: 4000
            });
        }
    }

    async function buscarCidades() {
        const cidadess = await CidadesService.buscarCidades();
        setCidades(cidadess);
    }

    const formik = useFormik({
        initialValues: {
            CPF: '',
            Nome: '',
            Telefone: '',
            Email: '',
            CEP: '',
            Cidade: '',
            UF: ''
        },
        validationSchema: Yup.object({
            Nome: Yup.string()
                .required('Obrigatório')
                .test('Validar Nome Completo', 'Informe o nome completo', validarNomeCompleto),
            CPF: Yup.string()
                .required('Obrigatório')
                .test('Validar CPF', 'CPF Inválido', cpfToValidate => {
                    return validarCPF(cpfToValidate || '');
                }),
            Telefone: Yup.string()
                .required('Obrigatório')
                .test('Validar Telefone', 'Telefone Inválido', telefoneToValidate => {
                    if (telefoneToValidate
                        .replace(/_/g, '')
                        .replace(/\(/g, '')
                        .replace(/\)/g, '')
                        .replace(/-/g, '')
                        .replace(/\./g, '')
                        .replace(/\s/g, '')
                        .length !== 11) {
                        return false;
                    }

                    return true;
                }),
            Email: Yup.string().email('Digite um email Válido').required('Obrigatório')
        }),
        onSubmit: () => {

        }
    })

    useEffect(() => {
        const cidade = cidades.find(c => c.cidade == formik.values.Cidade);

        if (!cidade) {
            return;
        }

        setEndereco({ Cidade: formik.values.Cidade, CEP: '', UF: cidade!.estado, Bairro: '' });
    }, [formik.values.Cidade])

    async function verificarRecaptcha() {
        try {
            const grecaptcha = (window as any).grecaptcha;
            const token = await grecaptcha.execute('6LdL-BcsAAAAAMp9u6pw0p90qR518KgqzfiSihU3', { action: 'submit' })!;
            return token;
        } catch (error: any) {
            toast({
                variant: 'destructive',
                description: error,
                duration: 4000
            });
            return null;
        }
    }

    async function gerarQrCodeCompraRapida(usuario?: CadastrarUsuarioCompraRapidaDto) {
        try {
            setSubmiting(true);
            const cpf = normalizarCPF(formik.values.CPF);
            if (cpf.length !== 11) {
                return;
            }

            if (!validarCPF(cpf)) {
                toast({
                    variant: 'destructive',
                    description: 'CPF Inválido',
                    duration: 4000
                });
                return;
            }

            const token = await verificarRecaptcha();
            if (!token) {
                return;
            }

            const dadosCheckout = {
                QtdTitulo: quantidade,
                CPF: cpf,
                IdVendedor: StorageUtils.getIdVendedor(),
                RecaptchaToken: token,
                Usuario: usuario
            } as DadosCheckoutCompraRapidaDto

            const { Data: qrCodeGerado } = await CompraRapidaService.CheckoutCompraRapida(dadosCheckout);

            await toast({
                variant: 'success',
                description: 'QRCode gerado com sucesso',
                duration: 4000
            });

            StorageUtils.removeIdVendedor();

            navigate('/compra/rapida/qrcode', {
                state: { qrCode: qrCodeGerado, token: qrCodeGerado.TokenCompraRapida },
            });
            navigate(0);
        } catch (error: any) {
            if (error === 'CPF não encontrado;') {
                setUsuario(undefined);
                formik.setValues({ ...formik.values, Nome: '', Email: '', Telefone: '' })
                setEtapa(EtapasCompraRapida.CadastrarDados)
                return;
            }
            toast({
                variant: 'destructive',
                description: error,
                duration: 4000
            });
        } finally {
            setSubmiting(false);
        }
    }

    useEffect(() => {
        const cep = formik.values.CEP.replace(/_/g, '').replace(/-/g, '');
        if (cep.length !== 8) {
            setEndereco(undefined);
            return;
        }

        BuscarPorCep(cep)
    }, [formik.values.CEP])

    async function handleCadastrarEFinalizarCompra() {
        const novoUsuario = {
            CPF: normalizarCPF(formik.values.CPF),
            Email: formik.values.Email,
            Telefone: formik.values.Telefone.replace(/_/g, '')
                .replace(/\(/g, '')
                .replace(/\)/g, '')
                .replace(/-/g, '')
                .replace(/\./g, '')
                .replace(/\s/g, ''),
            Nome: formik.values.Nome,
            Endereco: {
                CEP: endereco?.CEP.replace(/_/g, '').replace(/-/g, ''),
                Cidade: endereco?.Cidade,
                Estado: '',
                UF: endereco?.UF,
                Numero: '',
                Bairro: '',
                Logradouro: ''
            },
            Senha: ''
        } as CadastrarUsuarioCompraRapidaDto

        gerarQrCodeCompraRapida(novoUsuario)
    }

    async function handleLoginEFinalizarCompra() {
        try {
            setFinalizandoCompra(true)
            if (!usuario) {
                return;
            }

            let result: IRealizarLoginDTO;

            const idVendedor = StorageUtils.getIdVendedor();

            if (usuario.idUsuario === 0) {
                const dadosCadastro = {
                    CPF: normalizarCPF(formik.values.CPF),
                    Email: formik.values.Email,
                    Telefone: formik.values.Telefone.replace(/_/g, '')
                        .replace(/\(/g, '')
                        .replace(/\)/g, '')
                        .replace(/-/g, '')
                        .replace(/\./g, '')
                        .replace(/\s/g, ''),
                    Nome: formik.values.Nome,
                    Endereco: {
                        CEP: endereco?.CEP.replace(/_/g, '').replace(/-/g, ''),
                        Cidade: endereco?.Cidade,
                        Estado: '',
                        UF: endereco?.UF,
                        Numero: '',
                        Bairro: '',
                        Logradouro: ''
                    },
                    Senha: ''
                } as CadastrarUsuarioCompraRapidaDto
                const { Data } = await CompraRapidaService.realizarCadastro(dadosCadastro);
                result = Data;
            } else {
                const { Data } = await CompraRapidaService.realizarLoginSimples(usuario?.CPF, usuario?.Telefone);
                result = Data;
            }

            const { Data: qrCodeGerado } = await CompraRapidaService.finalizarCompraPix(quantidade, result.TokenAcesso, idVendedor);

            await toast({
                variant: 'success',
                description: 'QRCode gerado com sucesso',
                duration: 4000
            });

            StorageUtils.removeIdVendedor();

            navigate('/compra/rapida/qrcode', {
                state: { qrCode: qrCodeGerado, token: result.TokenAcesso },
            });
            navigate(0);
        } catch (error: any) {
            toast({
                variant: 'destructive',
                description: error,
                duration: 4000
            });
        } finally {
            setFinalizandoCompra(false)
        }
    }

    return (
        <>
            {
                location.pathname.toLowerCase().indexOf('/compra/rapida') >= 0 && (
                    <h1 className="text-3xl font-semibold text-center text-primary mb-5 mt-1">COMPRA RÁPIDA</h1>
                )
            }

            <ScrollArea>
                <Card className="mx-auto max-w-sm py-5 mb-5">
                    <CardContent>
                        <div className="flex justify-end mb-2">
                            <CompraRapidaOqueE />
                        </div>
                        {
                            etapa === EtapasCompraRapida.SelecionarQuantidade && (
                                <EtapaSelecionarQuantidade
                                    alterarEtapa={setEtapa}
                                    alterarQuantidade={setQuantidade}
                                    quantidade={quantidade} />
                            )
                        }
                        {
                            etapa !== EtapasCompraRapida.SelecionarQuantidade && (
                                <>
                                    <div className="flex justify-center flex-col items-center">
                                        <h1 className="text-center text-primary font-semibold">
                                            Quantidade Selecionada
                                        </h1>
                                        <p className="text-center text-primary text-2xl">
                                            {quantidade}
                                        </p>
                                    </div>
                                    <Separator />
                                </>
                            )
                        }
                        {
                            (etapa === EtapasCompraRapida.InserirCPF || etapa === EtapasCompraRapida.CadastrarDados) && (
                                <>
                                    <div className="flex flex-col">
                                        <EtapaInserirCPF
                                            etapa={etapa}
                                            formik={formik}
                                            submiting={submiting} />

                                        {
                                            etapa === EtapasCompraRapida.CadastrarDados && (
                                                <EtapaCadastrar cidades={cidades} formik={formik} submiting={submiting} />
                                            )
                                        }
                                        <div>

                                        </div>
                                        <div className="flex justify-center gap-2 mt-5">
                                            <Button
                                                disabled={quantidade === 0 || submiting}
                                                type="button"
                                                onClick={() => {
                                                    setEtapa(EtapasCompraRapida.SelecionarQuantidade)
                                                    setUsuario(undefined);
                                                    setEndereco(undefined);
                                                    formik.resetForm();
                                                }}
                                                variant="foreground"
                                                className="mt-2">
                                                Voltar
                                            </Button>
                                            {
                                                etapa === EtapasCompraRapida.CadastrarDados && (
                                                    <Button
                                                        disabled={quantidade === 0 || !formik.isValid || !endereco || submiting}
                                                        type="button"
                                                        onClick={handleCadastrarEFinalizarCompra}
                                                        variant="foreground"
                                                        className="mt-2">
                                                        Continuar
                                                    </Button>
                                                )
                                            }

                                            {
                                                etapa === EtapasCompraRapida.InserirCPF && (
                                                    <Button
                                                        disabled={submiting || quantidade === 0 || !validarCPF(formik.values.CPF)}
                                                        type="button"
                                                        onClick={() => gerarQrCodeCompraRapida()}
                                                        variant="foreground"
                                                        className="mt-2">
                                                        Gerar QRCode
                                                    </Button>
                                                )
                                            }
                                        </div>
                                    </div>
                                </>
                            )
                        }

                        {
                            usuario && etapa === EtapasCompraRapida.Resumo && (
                                <EtapaResumo
                                    finalizandoCompra={finalizandoCompra}
                                    quantidade={quantidade}
                                    usuario={usuario}
                                    alterarUsuario={setUsuario}
                                    formik={formik}
                                    alterarEtapa={setEtapa}
                                    handleLoginEFinalizarCompra={handleLoginEFinalizarCompra} />
                            )
                        }
                    </CardContent>
                </Card>

                {
                    location.pathname.toLowerCase().indexOf('/compra/rapida') >= 0 && (
                        <div className="mb-5 flex flex-col justify-center items-center">
                            <div className="my-3 text-primary-foreground text-center">
                                <span>
                                    Deseja visualizar suas compras?
                                    <br />
                                    <NavLink to="/AutenticarPorCodigo">
                                        <Button type="button" className="gap-2">
                                            Clique Aqui!
                                        </Button>
                                    </NavLink>
                                </span>
                            </div>
                            <NavLink to="/compra/titulos">
                                <img className="rounded-lg" src={dadosSorteioVigente.ImagemPremio} />
                            </NavLink>
                        </div>
                    )
                }
            </ScrollArea>
        </>
    )
}